export default {
  experience: `profile/work-experience`,
  update: `profile/work-experience/update`,
  remove: `profile/work-experience/remove`,
};
